export const TEST_ID_MOBILE_SUMMARY_CLIENT_NAME = 'mobile-summary-client-name';

export const TEST_ID_MOBILE_SUMMARY_CLIENT_CHANGE_BTN =
  'mobile-summary-client-change-btn';
